"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwoFactorManagementClient = void 0;
const InvalidSpinError_1 = require("./errors/InvalidSpinError");
const MissingScopeSpinError_1 = require("./errors/MissingScopeSpinError");
class TwoFactorManagementClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.getGdcType = (isWcar) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
        this.resourceHostId = `myvw-2fm-${stage}`;
    }
    async getSpinState(isWcar) {
        const response = await this.authService.get(this.resourceHostId, `v2/spin/state/user/__userId__?gdc=${this.getGdcType(isWcar)}`);
        const spinResponse = await response.json();
        if (response.status === 403 && spinResponse.type === '/errors/403-3') {
            throw new MissingScopeSpinError_1.MissingScopeSpinError();
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return spinResponse;
    }
    async changeSpin(currentSpin, newSpin, isWcar) {
        const spinChangeBody = {
            existingSPin: currentSpin,
            newSPin: newSpin,
        };
        const response = await this.authService.patch(this.resourceHostId, `v2/spin/user/__userId__?gdc=${this.getGdcType(isWcar)}`, JSON.stringify(spinChangeBody), { 'Content-Type': 'application/json' });
        if (response.status === 403) {
            throw new InvalidSpinError_1.InvalidSpinError();
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    async resetSpin(newSpin, isWcar) {
        const spinResetBody = { newSPin: newSpin };
        const response = await this.authService.put(this.resourceHostId, `v2/spin/user/__userId__?gdc=${this.getGdcType(isWcar)}`, JSON.stringify(spinResetBody), { 'Content-Type': 'application/json' });
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    async verifySpin(currentSpin, isWcar) {
        const verifySpinBody = {
            spin: currentSpin,
        };
        const response = await this.authService.post(this.resourceHostId, `v2/spin/verify/user/__userId__?gdc=${this.getGdcType(isWcar)}`, JSON.stringify(verifySpinBody), { 'Content-Type': 'application/json' });
        const spinResponse = await response.json();
        if (response.status === 403 && spinResponse.type === '/errors/403-4') {
            throw new InvalidSpinError_1.InvalidSpinError();
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return spinResponse.value;
    }
}
exports.TwoFactorManagementClient = TwoFactorManagementClient;
//# sourceMappingURL=TwoFactorManagementClient.js.map